import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const bkc: AreaConfig = {
  name: 'BKC & Bandra',
  slug: 'bkc-bandra',
  tagline: 'Premium iPhone Repair Near BKC & Bandra — Doorstep Service',
  description: 'Skip the Apple Store queue at Jio World Drive. minto brings certified technicians to your home or office in BKC, Bandra West, Khar, and Santacruz. OEM-quality parts, zero \"Unknown Part\" warnings, and 6-month warranty — all at your doorstep in 30 minutes.',
  localities: [
    'BKC', 'Bandra West', 'Bandra East', 'Khar West', 'Khar East',
    'Santacruz West', 'Santacruz East', 'Pali Hill', 'Carter Road',
    'Turner Road', 'Hill Road', 'Linking Road', 'Reclamation',
    'Kalanagar', 'Band Stand',
  ],
  zones: [
    {
      name: 'BKC & Kalanagar',
      line: 'Western Line',
      station: 'Bandra Station / BKC Metro',
      localities: ['BKC', 'Kalanagar', 'MMRDA Grounds', 'Jio World Drive', 'Platinum Tower', 'Bandra East Corporate Zone'],
      desc: 'Covering the BKC corporate district and surroundings. Our technicians reach any office in BKC within 30 minutes — get your iPhone fixed during lunch break.',
    },
    {
      name: 'Bandra West & Pali Hill',
      line: 'Western Line',
      station: 'Bandra Station',
      localities: ['Pali Hill', 'Carter Road', 'Band Stand', 'Turner Road', 'Hill Road', 'Chapel Road', 'Bandra Reclamation', 'Mount Mary'],
      desc: 'Premium residential Bandra West. We come to your apartment — no need to travel to the Apple Store at BKC or any service center.',
    },
    {
      name: 'Khar & Santacruz',
      line: 'Western Line',
      station: 'Khar Station / Santacruz Station',
      localities: ['Khar West', 'Khar East', 'Santacruz West', 'Santacruz East', 'Linking Road', 'Khar Danda', 'SV Road Khar'],
      desc: 'Adjacent premium neighborhoods with quick 30-45 minute technician arrival. Popular for screen and battery replacements.',
    },
  ],
  seo: {
    title: 'iPhone Repair Near BKC & Bandra | Apple Store Alternative | Doorstep Service | minto',
    description: 'Premium doorstep iPhone repair near BKC & Bandra West, Mumbai. Apple Store alternative with OEM parts, no Unknown Part warning, 6-month warranty. Battery replacement, screen repair. 30-min service at your location.',
    keywords: 'iPhone repair BKC, mobile repair Bandra, Apple Store BKC alternative, iPhone battery replacement BKC, doorstep iPhone repair Bandra West, phone repair Pali Hill, screen replacement Bandra, mobile repair Khar West, iPhone service center near BKC, Santacruz phone repair, battery replacement near Apple Store Mumbai',
  },
  faqs: [
    {
      q: 'Is minto a good alternative to the Apple Store at BKC?',
      a: 'Yes! We use OEM-quality parts that produce zero \"Unknown Part\" warnings on your iPhone. Unlike the Apple Store, we come to your home or office — no appointment slots, no waiting in queue. Plus our pricing starts 40-50% lower for battery replacements.',
    },
    {
      q: 'How quickly can a technician reach BKC or Bandra?',
      a: 'Our technicians typically arrive within 30-45 minutes anywhere in BKC, Bandra West, Bandra East, or Khar. For corporate offices in BKC, we can also schedule a specific time slot.',
    },
    {
      q: 'Do you repair the latest iPhones (iPhone 14, 15 series)?',
      a: 'Yes, we repair all iPhone models from iPhone XR to the latest iPhone 15 Pro Max. Battery replacement, screen repair, back glass replacement, and more.',
    },
    {
      q: 'Will I get the \"Unknown Part\" warning after battery replacement?',
      a: 'No. We use OEM-grade batteries and calibrate them properly so your iPhone shows normal battery health without any unknown part warning messages.',
    },
    {
      q: 'What warranty do you offer on iPhone battery replacement?',
      a: 'All battery replacements come with 6 months (180 days) warranty. If the battery develops any issue within this period, we replace it free of charge.',
    },
  ],
};

const BKCPage: React.FC = () => <AreaLandingPage area={bkc} />;
export default BKCPage;
